export const FALLBACK_REGIONAL_LABEL = "o Regional";
